import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import daysOfWeek from '../../models/days-of-week';

const styles = {
  buttonGroup: {
    width: '100%',
    paddingTop: '6px',
    marginBottom: '10px',
    flexWrap: 'wrap',
  },
  button: {
    flex: '1',
    fontSize: '0.75rem',
  },
};

const WeekdayToggleButtons = ({
  buttonStyle, buttonGroupStyle, value, onChange,
}) => (
  <ToggleButtonGroup value={value} onChange={onChange} style={buttonGroupStyle || styles.buttonGroup}>
    {daysOfWeek.map(d => <ToggleButton key={d.id} value={d.id} style={buttonStyle || styles.button}>{d.name}</ToggleButton>)}
  </ToggleButtonGroup>
);

WeekdayToggleButtons.propTypes = {
  buttonStyle: PropTypes.object,
  buttonGroupStyle: PropTypes.object,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

WeekdayToggleButtons.defaultProps = {
  buttonStyle: null,
  buttonGroupStyle: null,
  value: [],
};

export default WeekdayToggleButtons;
